import { render, staticRenderFns } from "./remote_dashboard.vue?vue&type=template&id=6f380314&scoped=true&"
import script from "./remote_dashboard.vue?vue&type=script&lang=js&"
export * from "./remote_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./remote_dashboard.vue?vue&type=style&index=0&id=6f380314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f380314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6f380314', component.options)
    } else {
      api.reload('6f380314', component.options)
    }
    module.hot.accept("./remote_dashboard.vue?vue&type=template&id=6f380314&scoped=true&", function () {
      api.rerender('6f380314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/dashboard/remote_dashboard.vue"
export default component.exports